const pokemons = [
    {
      id: 1,
      name: "Glumanda",
      images: [
        "https://poke-meta.com/static/images/pokemon/glumanda.png",
        "https://poke-meta.com/static/images/pokemon/glutexo.png",
        "https://poke-meta.com/static/images/pokemon/glurak.png"
      ]
    },
    {
      id: 2,
      name: "Bisasam",
      images: ["https://poke-meta.com/static/images/pokemon/bisasam.png",
        "https://poke-meta.com/static/images/pokemon/bisaknosp.png",
        "https://poke-meta.com/static/images/pokemon/bisaflor.png"] // Keine Entwicklung
    },
    {
      id: 3,
      name: "bauz",
      images: ["https://poke-meta.com/static/images/pokemon/bauz.png",
        "https://poke-meta.com/static/images/pokemon/bauz2.png",
        "https://poke-meta.com/static/images/pokemon/bauz3.png"] // Keine Entwicklung
    }
    ,
    {
      id: 4,
      name: "Lithomith",
      images: ["https://poke-meta.com/static/images/pokemon/Lithomith.png",
        "https://poke-meta.com/static/images/pokemon/castellith.png"] // Keine Entwicklung
    }
    ,
    {
      id: 5,
      name: "enton",
      images: ["https://poke-meta.com/static/images/pokemon/enton.png"] // Keine Entwicklung
    }
    ,
    {
      id: 6,
      name: "trasla",
      images: ["https://poke-meta.com/static/images/pokemon/trasla.png",
        "https://poke-meta.com/static/images/pokemon/kirlia.png",
        "https://poke-meta.com/static/images/pokemon/guardevoir.png"] // Keine Entwicklung
    }
    ,
    {
      id: 7,
      name: "machollo",
      images: ["https://poke-meta.com/static/images/pokemon/machollo.png",
        "https://poke-meta.com/static/images/pokemon/maschock.png",
        "https://poke-meta.com/static/images/pokemon/machomei.png"] // Keine Entwicklung
    }
    ,
    {
      id: 8,
      name: "pikachu",
      images: ["https://poke-meta.com/static/images/pokemon/pikachu.png"] // Keine Entwicklung
    }
    ,
    {
      id: 9,
      name: "pummeluff",
      images: ["https://poke-meta.com/static/images/pokemon/pummeluff.png",
        "https://poke-meta.com/static/images/pokemon/knuddeluff.png"] // Keine Entwicklung
    }
    ,
    {
      id: 10,
      name: "quiekel",
      images: ["https://poke-meta.com/static/images/pokemon/quiekel.png",
        "https://poke-meta.com/static/images/pokemon/keifel.png"] // Keine Entwicklung
    }
    ,
    {
      id: 11,
      name: "urgl",
      images: ["https://poke-meta.com/static/images/pokemon/urgl.png"] // Keine Entwicklung
    }
    ,
    {
      id: 12,
      name: "zorua",
      images: ["https://poke-meta.com/static/images/pokemon/zorua.png",
        "https://poke-meta.com/static/images/pokemon/zoroark.png"] // Keine Entwicklung
    }
    ,
  
      {
      id: 13,
      name: "Schiggy",
      images: ["https://poke-meta.com/static/images/pokemon/schiggy.png",
        "https://poke-meta.com/static/images/pokemon/schillok.png",
        "https://poke-meta.com/static/images/pokemon/turtok.png"] // Keine Entwicklung
    },
    {
      id: 14,
      name: "froxy",
      images: ["https://poke-meta.com/static/images/pokemon/froxy.png",
        "https://poke-meta.com/static/images/pokemon/froxy2.png",
        "https://poke-meta.com/static/images/pokemon/froxy3.png"] // Keine Entwicklung
    },
    {
      id: 15,
      name: "fynx",
      images: ["https://poke-meta.com/static/images/pokemon/fynx.png",
        "https://poke-meta.com/static/images/pokemon/fynx2.png",
        "https://poke-meta.com/static/images/pokemon/fynx3.png"] // Keine Entwicklung
    },
    {
      id: 16,
      name: "hopplo",
      images: ["https://poke-meta.com/static/images/pokemon/hopplo.png",
        "https://poke-meta.com/static/images/pokemon/hopplo2.png",
        "https://poke-meta.com/static/images/pokemon/hopplo3.png"] // Keine Entwicklung
    },
    {
      id: 17,
      name: "vulpix",
      images: ["https://poke-meta.com/static/images/pokemon/vulpix.png",
        "https://poke-meta.com/static/images/pokemon/vulpix2.png"] // Keine Entwicklung
    },
    {
      id: 18,
      name: "zeraora",
      images: ["https://poke-meta.com/static/images/pokemon/zeraora.png"] // Keine Entwicklung
    },
    {
      id: 19,
      name: "pantimos",
      images: ["https://poke-meta.com/static/images/pokemon/pantimos.png"] // Keine Entwicklung
    },
    {
      id: 20,
      name: "nachtara",
      images: ["https://poke-meta.com/static/images/pokemon/nachtara.png"] // Keine Entwicklung
    },
    {
      id: 21,
      name: "folipurba",
      images: ["https://poke-meta.com/static/images/pokemon/folipurba.png"] // Keine Entwicklung
    },
    {
      id: 22,
      name: "lucario",
      images: ["https://poke-meta.com/static/images/pokemon/lucario.png"] // Keine Entwicklung
    },
    {
      id: 23,
      name: "absol",
      images: ["https://poke-meta.com/static/images/pokemon/absol.png"] // Keine Entwicklung
    },
    {
      id: 24,
      name: "feelinara",
      images: ["https://poke-meta.com/static/images/pokemon/feelinara.png"] // Keine Entwicklung
    },
    {
      id: 25,
      name: "glaciola",
      images: ["https://poke-meta.com/static/images/pokemon/glaciola.png"] // Keine Entwicklung
    },
    {
      id: 26,
      name: "psiana",
      images: ["https://poke-meta.com/static/images/pokemon/psiana.png"] // Keine Entwicklung
    },
    {
      id: 27,
      name: "lapras",
      images: ["https://poke-meta.com/static/images/pokemon/lapras.png"] // Keine Entwicklung
    },
    {
      id: 28,
      name: "cottini",
      images: ["https://poke-meta.com/static/images/pokemon/cottini.png",
        "https://poke-meta.com/static/images/pokemon/cottini2.png"] // Keine Entwicklung
    },
    {
      id: 29,
      name: "dakuma",
      images: ["https://poke-meta.com/static/images/pokemon/dakuma.png",
        "https://poke-meta.com/static/images/pokemon/dakuma2.png"] // Keine Entwicklung
    },
    {
      id: 30,
      name: "frubberl",
      images: ["https://poke-meta.com/static/images/pokemon/frubberl.png",
        "https://poke-meta.com/static/images/pokemon/frubberl2.png"] // Keine Entwicklung
    },
    {
      id: 31,
      name: "memmeon",
      images: ["https://poke-meta.com/static/images/pokemon/memmeon.png",
        "https://poke-meta.com/static/images/pokemon/memmeon2.png",
         "https://poke-meta.com/static/images/pokemon/memmeon3.png",] // Keine Entwicklung
    },
    {
      id: 32,
      name: "despotar",
      images: ["https://poke-meta.com/static/images/pokemon/despotar.png"] // Keine Entwicklung
    },
    {
      id: 33,
      name: "dragoran",
      images: ["https://poke-meta.com/static/images/pokemon/dragoran.png"] // Keine Entwicklung
    },
    {
      id: 34,
      name: "gengar",
      images: ["https://poke-meta.com/static/images/pokemon/gengar.png"] // Keine Entwicklung
    },
    {
      id: 35,
      name: "pixi",
      images: ["https://poke-meta.com/static/images/pokemon/pixi.png"] // Keine Entwicklung
    },
    {
      id: 36,
      name: "relaxo",
      images: ["https://poke-meta.com/static/images/pokemon/relaxo.png"] // Keine Entwicklung
    },
    {
      id: 37,
      name: "zapdos",
      images: ["https://poke-meta.com/static/images/pokemon/zapdos.png"] // Keine Entwicklung
    },
    {
      id: 38,
      name: "korraidon",
      images: ["https://poke-meta.com/static/images/pokemon/korraidon.png"] // Keine Entwicklung
    },
    {
      id: 39,
      name: "mewtwo",
      images: ["https://poke-meta.com/static/images/pokemon/mewtwo.png"] // Keine Entwicklung
    },
    
  ];
  export default pokemons;